import React from "react";
import {
    Label,
    Wrapper,
} from "./styled.js";
import Select from 'react-select';

const values = [
    'Incomplete',
    'On Hold',
    'In Progress',
    'Complete',
];
const options = values.map(value =>({ label: value, value }));

export const Task = ({ label, placeholder, required,
                                value = '', onChange, error,
                                disabled }) => {
    const selectedOption = options[values.indexOf(value)];
    const handleOnChange = value =>{
        if (!onChange) {
            return;
        }

        onChange(value ? value.value: '');
    };
    return <Wrapper className="select-box">
        {label && <Label required={required}>{label}</Label>}
        <Select
            className={ error ? 'data-error': ''}
            classNamePrefix="react-select"
            placeholder={placeholder}
            required={required}
            options={options}
            isClearable={!required}
            value={selectedOption}
            onChange={handleOnChange}
            isDisabled={disabled}
        />
    </Wrapper>
};

export default Task;
